import { Err, ResponseData } from 'types';

import { http } from '.';

export const getCreditors = async () => {
  return await http.get<Err, ResponseData<any>>(
    `Dashboard/TabReport?isInvoice=false&pageIndex=0&pageSize=10`
  );
};

export const getDebitors = async () => {
  return await http.get<Err, ResponseData<any>>(
    `Dashboard/TabReport?isInvoice=true&pageIndex=0&pageSize=10`
  );
};
export const getDebitorBalances = async (
  pageSize: number,
  pageIndex: number,
  partnerName?: string
) => {
  const encodedName = partnerName ? encodeURIComponent(partnerName) : '';
  return await http.get<Err, ResponseData<any>>(
    `Dashboard/DebitorBalances?PageIndex=${pageIndex}&PageSize=${pageSize}&partnerName=${encodedName}`
  );
};

export const getCreditorBalances = async (
  pageSize: number,
  pageIndex: number,
  partnerName?: string
) => {
  const encodedName = partnerName ? encodeURIComponent(partnerName) : '';
  return await http.get<Err, ResponseData<any>>(
    `Dashboard/GetCreditorBalances?PageIndex=${pageIndex}&PageSize=${pageSize}&partnerName=${encodedName}`
  );
};

export const getDebitorSummary = async () => {
  return await http.get<Err, ResponseData<any[]>>(
    `Dashboard/GetDebitorBalanceSummary`
  );
};

export const getCreditorSummary = async () => {
  return await http.get<Err, ResponseData<any[]>>(
    `Dashboard/GetCreditorBalanceSummary`
  );
};
